import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { SearchBarService } from '../../services/search-bar/search-bar.service';
import { PipesModule } from '../../pipes/pipes.module';

@Component({
	selector: 'app-search-bar',
	standalone: true,
	imports: [CommonModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatIconModule, MatIcon, MatIconButton, PipesModule],
	providers: [SearchBarService],
	templateUrl: './search-bar.component.html',
	styleUrl: './search-bar.component.scss'
})
export class SearchBarComponent {

	@Input() placeholder: string = 'general.search';
	@Input() isCaseSensitiveSearch: boolean = false;
	@Output() searchString = new EventEmitter<string>();
	searchTerm: string = '';

	constructor() { }

	private emitSearchTerm(): void {
		this.searchString.emit(this.isCaseSensitiveSearch ? this.searchTerm : this.searchTerm.toLowerCase());
	}

	onSearch(): void {
		this.emitSearchTerm();
	}

	clearSearch(): void {
		this.searchTerm = '';
		this.emitSearchTerm();
	}

}
